import React from 'react'
import AdminHeader from '../../../Components/AdminComponent/AdminHeader/AdminHeader'
import AdminSidebar from '../../../Components/AdminComponent/AdminSidebar/AdminSidebar'
import AssignUsersToManagerComponent from '../../../Components/AdminComponent/AssignUsersToManagerComponent/AssignUsersToManagerComponent'

const AssignUsersToManager = () => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
    <AdminHeader />
    <div className='row col-lg-12'>
        <AdminSidebar />
        <div className='col-lg-10 right_content'>
            <AssignUsersToManagerComponent />
        </div>
    </div>
</div>
  )
}

export default AssignUsersToManager
